import React, { useEffect } from "react";
import MasterSegmentTable from "./MasterSegmentTable";
import MasterSegmentAdd from "./MasterSegmentAdd";
import MasterSegmentEdit from "./MasterSegmentEdit";
import useApiNew from "../../../utils/useApiNew";
import axios from "axios";
import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import DeleteAlert from "../../../components/ui/DeleteAlert";
import { errorNotify, successNotify } from "../../../Services/Notification";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const getSegmentAPI = `${process.env.REACT_APP_API_URL}api/segment`;
const exportSegmentAPI = `${process.env.REACT_APP_API_URL}api/export-segment`;

const MasterSegment = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [globalFilters, setGlobalFilters] = React.useState();
  const [bankData, setBankData] = React.useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  const name = "segment";

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  let { data, loading } = useApiNew(
    getSegmentAPI,
    "GET",
    { headers },
    renderKey,
  );

  data = data?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));

  const filterBankData = () => {
    let filterData = data;
    if (globalFilters) {
      filterData = data.filter(
        (item) =>
          item?.name?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setBankData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters]);
  console.log(data);

  // ADD

  const handleAddSegment = async (data) => {
    setIsButtonClicked(true);
    const addSegmentAPI = `${process.env.REACT_APP_API_URL}api/segment`;

    try {
      const res = await axios.post(addSegmentAPI, data, { headers });
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT
  const handleEditSegment = async (segmentId, data) => {
    setIsButtonClicked(true);
    const addSegmentAPI = `${process.env.REACT_APP_API_URL}api/segment/${segmentId}`;

    try {
      const res = await axios.put(addSegmentAPI, data, { headers });
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteSegment = async () => {
    const deleteSegmentAPI = `${getSegmentAPI}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteSegmentAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportSegmentAPI;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  // download
  const downloadSegment = () => {
    setIsDownloadClicked(true);
    const filename = `Segment-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Segment"];

  const buttonConfig = {
    value: "segment",
    name: "Segment",
    addHandler: handleAddSegment,
    editHandler: handleEditSegment,
    deleteHandler: handleDeleteSegment,
    downloadHandler: downloadSegment,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterSegmentTable
        tableData={globalFilters ? bankData : data}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        setGlobalFilters={setGlobalFilters}
        loading={loading}
        actionPermissions={actionPermissions("masters", "Segment")}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && (
        <MasterSegmentAdd
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isEdit && (
        <MasterSegmentEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterSegment;
